<div class="loader-overlay" *ngIf="loading">
    <div class="loader-container">
        <!-- Assessment Progress Spinner -->
        <div class="spinner">
            <div class="progress-ring progress-blue"></div>
            <div class="center-dot"></div>
        </div>

        <!-- Clean Loading Text -->
        <div class="loading-text">
            <span class="loading-message">{{ loadingMessage }}</span>
        </div>
    </div>
</div>